<template>
  <mdb-container class="d-flex justify-content-center wrapper3" center fluid id="maincarlist">
    <mdb-row class="d-flex justify-content-center firstrow3">
      <div class='container liststyle'>
        <mdb-container class="topmargins">
          <mdb-tab class="tabpadding" tabs color="white" justify>
            <mdb-tab-item :active="pillsActive==0" @click.native.prevent="pillsActive=0">
              <span class="tabsfonrt">수입차 가격표</span>
            </mdb-tab-item>
            <mdb-tab-item :active="pillsActive==1" @click.native.prevent="pillsActive=1">
              <span class="tabsfonrt">국산차 가격표</span>
            </mdb-tab-item>
          </mdb-tab>
          <mdb-tab-content>
            <mdb-tab-pane class="fade" key="show1" v-if="pillsActive==0">
              <ul class='carIconlist'
                @click="listImportClick"
                @mouseover="listImportMouseOver"
                @mouseout="listImportMouseOut"
              >
                <li>
                  <brandImportIcon :list-array="filterImageBrand(brands, 'i')"/>
                </li>
              </ul>
              <mdb-container class="selectcon">
                <div class="comboselect">
                  <select color="dark" class="custom-select combowidthbrand"
                  @change="dropImportClick">
                    <option selected id=0>브랜드</option>
                    <option v-for="p in filterImageBrand(brands, 'i')"
                    :key="p.id" :id="p.id" :value="p.id">{{p.name}}</option>
                  </select>
                  <select v-if="dimportorderbyid === 1"
                  class="custom-select combowidthbrand" @change="dropCarGroupImportClick"
                  key='1-carGroupImportdropList' >
                    <option selected id=0>차량그룹</option>
                    <option v-for="p in filterCarGroup(carGroups, dimportid)"
                    :key="p.carGroupId" :id="p.carGroupId"
                    :value="p.carGroupId">{{p.carGroupName}}</option>
                  </select>
                  <select v-if="dimportorderbyid2 === 1"
                  class="custom-select combowidthcarname" @change="dropCarImportClick">
                    <option selected id=0>차량명</option>
                    <option v-for="pd in filterCar(cars, dimportid, dimportcargroupid)"
                    :key="pd.id" :id="pd.id"
                    :value="pd.id">{{pd.name}}</option>
                  </select>
                </div>
              </mdb-container>
              <div class='carlist d-none d-sm-block'
                v-if="simportorderbyid === 1" key='1-carImportImageList'>
                <carImageList :list-array="filterImage(cars, simportid, 'i')"/>
              </div>
              <div class='carlist d-none d-sm-block'
                v-else-if="simportorderbyid === 12" key='13-carImportImageList'>
                <carImageList :list-array="filterImageCar(cars, dimportcarid, 'i')"/>
              </div>
              <div class='carlistmobile d-block d-sm-none'
                v-if="simportorderbyid === 1" key='2-carImportImageListM'>
                <carImageListMobile :list-array="filterImage(cars, simportid, 'i')"/>
              </div>
              <div class='carlistmobile d-block d-sm-none'
                v-else-if="simportorderbyid === 12" key='13-carImportImageListM'>
                <carImageList :list-array="filterImageCar(cars, dimportcarid, 'i')"/>
              </div>
            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show2" v-if="pillsActive==1">
              <ul class='carIconlist'
                @click='listLocalClick'
                @mouseover='listLocalMouseOver'
                @mouseout='listLocalMouseOut'>
                <li>
                  <brandLocalIcon class='carlist' :list-array="filterImageBrand(brands, 'l')" />
                </li>
              </ul>
              <div>
                <select color="dark" class="custom-select combowidth" @change="dropLocalClick">
                  <option selected id=0>브랜드</option>
                  <option v-for="p in filterImageBrand(brands, 'l')"
                  :key="p.id" :id="p.id" :value="p.id">{{p.name}}</option>
                </select>
                <select v-if="dlocalorderbyid === 1"
                class="custom-select combowidth" @change="dropCarGroupLocalClick"
                key='1-carGroupImportdropList' >
                  <option selected id=0>차그룹</option>
                  <option v-for="p in filterCarGroup(carGroups, dlocalid)"
                  :key="p.carGroupId" :id="p.carGroupId"
                  :value="p.carGroupId">{{p.carGroupName}}</option>
                </select>
                <select v-if="dlocalorderbyid2 === 1"
                class="custom-select combowidth" @change="dropCarLocalClick">
                  <option selected id=0>차명</option>
                  <option v-for="pd in filterCar(cars, dlocalid, dlocalcargroupid)"
                  :key="pd.id" :id="pd.id"
                  :value="pd.id">{{pd.name}}</option>
                </select>
              </div>
              <div class='carlist d-none d-sm-block'
                v-if="slocalorderbyid === 1" key='1-carLocalImageList'>
                <carImageList :list-array="filterImage(cars, slocalid, 'l')"/>
              </div>
              <div class='carlist d-none d-sm-block'
                v-else-if="slocalorderbyid === 7" key='7-carLocalImageList'>
                <carImageList :list-array="filterImageCar(cars, dlocalcarid, 'l')"/>
              </div>
              <div class='carlistmobile d-block d-sm-none'
                v-if="slocalorderbyid === 1" key='1-carLocalImageListM'>
                <carImageListMobile :list-array="filterImage(cars, slocalid, 'l')"/>
              </div>
              <div class='carlistmobile d-block d-sm-none'
                v-else-if="slocalorderbyid === 7" key='7-carLocalImageListM'>
                <carImageListMobile :list-array="filterImageCar(cars, dlocalcarid, 'l')"/>
              </div>
            </mdb-tab-pane>
          </mdb-tab-content>
        </mdb-container>
      </div>
    </mdb-row>
  </mdb-container>
</template>

<script>
import brandImportIcon from '@/components/BrandImportIcon.vue';
import brandLocalIcon from '@/components/BrandLocalIcon.vue';
import carImageList from '@/components/CarImageList.vue';
import carImageListMobile from '@/components/CarImageListMobile.vue';
import { brand, car, carGroup } from '@/api';

export default {
  data() {
    return {
      pillsActive: 0,
      verticalWithin: 0,
      simportid: 0,
      dimportid: 0,
      dimportcargroupid: 0,
      dimportcarid: 0,
      simportorderbyid: 1,
      dimportorderbyid: 1,
      dimportorderbyid2: 1,
      slocalid: 0,
      dlocalid: 0,
      dlocalcargroupid: 0,
      dlocalcarid: 0,
      slocalorderbyid: 1,
      dlocalorderbyid: 1,
      dlocalorderbyid2: 1,
      selecimportimgsrc: '',
      seleclocalimgsrc: '',
      brands: [],
      cars: [],
      carGroups: [],
    };
  },
  components: {
    brandImportIcon,
    brandLocalIcon,
    carImageList,
    carImageListMobile,
  },
  created() {
    this.fetchData();
  },
  methods: {
    listImportClick(el) {
      const imglist = document.querySelectorAll('.mainimportimage');
      const simgsrc = el.target.src;
      if (simgsrc === this.selecimportimgsrc) return;
      imglist.forEach((elem) => {
        elem.src = elem.src.replace('_over.png', '.png');
      });
      el.target.src = el.target.src.replace('.png', '_over.png');
      this.selecimportimgsrc = el.target.src;
      this.simportid = parseInt(el.target.id, 10);
      this.simportorderbyid = 2;
      this.simportorderbyid = 1;
    },
    /* eslint-disable */
    filterImageBrand(Value, nation) {
      return Value.filter((item) => {
        return item.nation === nation;
      });
    },
    filterImage(Value, brandid, nation) {
      return Value.filter((item) => {
        if (brandid === 0 && item.nation === nation) {
          return true;
        }
        if (item.brandId === brandid && item.nation === nation) {
          return true;
        }
        return false;
      });
    },
    filterCar(Value, brandid, cargroupid) {
      return Value.filter((item) => {
        if (item.brandId === brandid && item.carGroupId === cargroupid) {
          return true;
        }
        return false;
      });
    },
    filterCarGroup(Value, brandid) {
      return Value.filter((item) => {
        if (item.brandId === brandid) {
          return true;
        }
        return false;
      });
    },
    filterImageCar(Value, carid, nation) {
      return Value.filter((item) => {
        if (item.id === carid && item.nation === nation) {
          return true;
        }
        return false;
      });
    },
    listImportMouseOver(el) {
      const simgsrc = el.target.src;
      if (!simgsrc) return;
      if (simgsrc === this.selecimportimgsrc) return;
      el.target.src = el.target.src.replace('.png', '_over.png');
    },
    listImportMouseOut(el) {
      const simgsrc = el.target.src;
      if (!simgsrc) return;
      if (simgsrc === this.selecimportimgsrc) return;
      el.target.src = el.target.src.replace('_over.png', '.png');
    },
    listLocalClick(el) {
      const imglist = document.querySelectorAll('.mainlocalimage');
      const simgsrc = el.target.src;
      if (simgsrc === this.seleclocalimgsrc) return;
      imglist.forEach((elem) => {
        elem.src = elem.src.replace('_over.png', '.png');
      });
      el.target.src = el.target.src.replace('.png', '_over.png');
      this.seleclocalimgsrc = el.target.src;
      this.slocalid = parseInt(el.target.id, 10);
      this.slocalorderbyid = 0;
      this.slocalorderbyid = 1;
    },
    listLocalMouseOver(el) {
      const simgsrc = el.target.src;
      if (!simgsrc) return;
      if (simgsrc === this.seleclocalimgsrc) return;
      el.target.src = el.target.src.replace('.png', '_over.png');
    },
    /* eslint no-param-reassign: "error" */
    listLocalMouseOut(el) {
      const simgsrc = el.target.src;
      if (!simgsrc) return;
      if (simgsrc === this.seleclocalimgsrc) return;
      el.target.src = el.target.src.replace('_over.png', '.png');
    },
    dropImportClick(el) {
      this.dimportorderbyid = 0;
      this.dimportorderbyid = 1;
      this.dimportid = parseInt(el.target.value, 10);
    },
    dropCarGroupImportClick(el) {
      this.dimportorderbyid2 = 0;
      this.dimportorderbyid2 = 1;
      this.dimportcargroupid = parseInt(el.target.value, 10);
    },
    dropCarImportClick(el) {
      this.dimportcarid = parseInt(el.target.value, 10);
      this.simportorderbyid = 12;
    },
    dropLocalClick(el) {
      this.dlocalorderbyid = 0;
      this.dlocalorderbyid = 1;
      this.dlocalid = parseInt(el.target.value, 10);
    },
    dropCarGroupLocalClick(el) {
      this.dlocalorderbyid2 = 0;
      this.dlocalorderbyid2 = 1;
      this.dlocalcargroupid = parseInt(el.target.value, 10);
    },
    dropCarLocalClick(el) {
      this.dlocalcarid = parseInt(el.target.value, 10);
      this.slocalorderbyid = 7;
    },
    fetchData() {
      brand.fetch()
        .then((data) => {
          this.brands = data.data;
        }),
      car.fetch()
        .then((data) => {
          this.cars = data.data;
        }),
      carGroup.fetch()
        .then((data) => {
          this.carGroups = data.data;
        });
    },
  },
};
</script>

<style scoped>
.firstrow3 {
  margin: 0px 0px !important;
  max-height: 100% !important;
  background-color: #212121;
}

.wrapper3 {
  background-color: #212121;
  max-width: 1900px;
  height: auto;
  margin: 0px 0px;
  padding: 0px 0px;
  align-content: center;
  align-items: center;
  align-self: center;
}

.container {
  max-width: 1348px;
  margin-right: auto;
  margin-left: auto;
}

.liststyle{
  max-width: 1348px;
  margin-top: 1px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}

.topmargins{
  margin-top: 20px;
}

.tabpadding{
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
  padding-left: 0px;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #ffa63c;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  font-weight: 700;
  font-family: 'Nanum Square','Nanum Gothic', 'Noto Sans KR',
    'Malgun Gothic', 'Roboto', Arial, Dotum, Gulim, Verdana, Tahoma;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
  color: black;
  font-weight: 700;
  font-family: 'Nanum Square','Nanum Gothic', 'Noto Sans KR',
    'Malgun Gothic', 'Roboto', Arial, Dotum, Gulim, Verdana, Tahoma;
}

.nav-link:focus, .nav-link:hover {
  text-decoration: none;
}

.importboard{
  text-decoration: underline;
  color: black;
}

.localboard{
  text-decoration: underline;
  color: black;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}

.carIconlist{
  list-style: none;
  padding-left: 0px;
  margin: 3px 0px 3px 0px;
}

.carlist{
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}

.tabsfonrt{
  color: black;
  font-weight: 700;
  font-family: 'Nanum Square','Nanum Gothic', 'Noto Sans KR',
    'Malgun Gothic', 'Roboto', Arial, Dotum, Gulim, Verdana, Tahoma;
}

.button{
  background: url('/static/images/icons/requestbutton.png') no-repeat center center;
  width: 145px;
  height: 30px;
}

.board {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.selectcon {
  background-color: rgba(0,0,0,0.2);
  max-width: 1019px;
  padding: 0 0px;
  margin: auto auto;
  align-items: center;
}

@media (max-width: 500px) {
  .selectcon {
  background-color: transparent;
  max-width: 1000px;
  padding: 0 0px;
  margin: auto auto;
  align-items: center;
  padding-right: 18px;
}
}

.combowidth {
  max-width: 339px;
  background-color: white;
  color: black;
}

.combowidthbrand {
  max-width: 339px;
  background-color: white;
  color: black;
}

.combowidthcarname {
  max-width: 339px;
  background-color: white;
  color: black;
}

@media (max-width: 500px){
  .combowidth {
    max-width: 300px;
    background-color: white;
    color: black;
  }
};

@media (max-width: 500px){
  .combowidthbrand {
    max-width: 300px;
    background-color: white;
    color: black;
  }
}

@media (max-width: 500px){
  .combowidthcarname {
    max-width: 300px;
    background-color: white;
    color: black;
  }
}
.custom-select:focus {
  border-color: black;
  outline: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}
</style>
